<app-generic-container>
    <!-- Usamos el panel genérico -->
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
        <div [className]="'chat-container'">
            <div [className]="'chat-list'">
                <div [className]="'chat-list-header-container'">
                    <div [className]="'chat-list-search-container'">
                        <div [className]="'chat-list-search-text-container'">
                            <input type="text" [className]="'chat-list-search-text'" [(ngModel)]="searchQuery"
                                (ngModelChange)="filterChats()" placeholder="Buscar chat">
                        </div>
                    </div>
                    <button [className]="'chat-list-add-button'" (click)="onClickNew()">
                        <fa-icon icon="plus" size="1x" [className]="'chat-list-add-button-icon'"></fa-icon>
                    </button>
                </div>


                <div [className]="'chat-list-container'">
                    <div *ngFor="let conversation of filteredChatsList" [className]="'chat-list-dialog-card'"
                        (click)="handleChatRoom(conversation)">
                        <div [className]="'chat-list-dialog-card-text-position'">
                            {{conversation.chatMembersInfo[0].userType}}
                            <!-- <div [className]="'chat-list-dialog-card-new'" *ngIf="conversation.lastMessageIsNew">
                                Nuevo
                            </div> -->

                        </div>
                        <div [className]="'chat-list-dialog-card-content'">
                            <div *ngIf="!conversation.chatMembersInfo[0].profileImage"
                                [className]="'chat-list-dialog-card-initials'">
                                {{conversation.chatMembersInfo[0].initials}}
                            </div>

                            <img *ngIf="conversation.chatMembersInfo[0].profileImage" alt="profile-img"
                                [src]="'data:'+conversation.chatMembersInfo[0].profileImage.mimeType+';base64,' + conversation.chatMembersInfo[0].profileImage.imageData"
                                [ngClass]="'chat-list-dialog-card-image'" />

                            <div [className]="'chat-list-dialog-card-text-container'">
                                <div class="chat-list-user-container">
                                    <span [className]="'chat-list-dialog-card-text-name'">
                                        {{conversation.chatMembersInfo[0].fullName}}</span>

                                    <span
                                        [className]="'chat-list-dialog-card-text-company'">{{conversation.company.name}}</span>
                                </div>

                                <span
                                    [className]="'chat-list-dialog-card-text-content'">{{conversation.lastMessage}}</span>
                            </div>

                        </div>
                        <div [className]="'chat-list-dialog-card-date'">
                            <span [className]="'chat-list-dialog-card-date-text'">
                                {{conversation.lastMessageTime !== '0001-01-01T00:00:00' ?
                                conversation.lastMessageTime : ' '}}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
            <div class="chat-dialog">
                <div *ngIf="loadingMessages "
                    class="d-flex justify-content-center align-items-center loading-container">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Cargando...</span>
                    </div>
                </div>
                <ng-container *ngIf="room">
                    <div class="chat-header">
                        <div class="chat-header-text">
                            {{headerInfo.chatMembersInfo[0].fullName}}
                            <span class="chat-header-company-text">
                                {{headerInfo.company.name}}
                            </span>
                        </div>
                        <div *ngIf="!headerInfo.chatMembersInfo[0].profileImage" [className]="'chat-header-initials'">
                            {{headerInfo.chatMembersInfo[0].initials}}
                        </div>

                        <img *ngIf="headerInfo.chatMembersInfo[0].profileImage" alt="profile-img"
                            [src]="'data:'+headerInfo.chatMembersInfo[0].profileImage.mimeType+';base64,' + headerInfo.chatMembersInfo[0].profileImage.imageData"
                            [ngClass]="'chat-header-image'" />
                    </div>
                    <div class="chat-messages-container">
                        <div *ngFor="let group of groupedMessages" class="chat-message-date-day-group">
                            <div class="chat-message-date-divider">{{ formatChatDividerDate(group.date) }}</div>
                            <div *ngFor="let message of group.messages"
                                [ngClass]="message.user !== currentSender ? 'chat-incomming-message' : 'chat-outcomming-message'">
                                <div>{{ message.messageText }}</div>
                                <div class="chat-message-date">
                                    <!-- <span *ngIf="message.isRead && message.sender === currentChatMember">Visto </span> -->
                                    {{ adjustTimeToSystemTimezone(message.sentAt).time }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="chat-input-container">
                        <textarea class="chat-input" placeholder="Escribe tu mensaje" [(ngModel)]="message"
                            (keydown)="onKeydown($event)" (input)="adjustTextareaHeight($event)"></textarea>

                        <button [className]="'chat-send-button'" (click)="onClickSend()">
                            <fa-icon icon="paper-plane" size="1x" [className]="'chat-send-icon'"></fa-icon>
                        </button>
                    </div>
                </ng-container>



            </div>
        </div>
    </app-generic-panel>
</app-generic-container>